import React from 'react';
import { Translate, I18n } from 'react-redux-i18n';
import { connect } from 'react-redux';
import StringMask from 'string-mask';

import Table from '../components/table/table';
import ModalComponent from '../components/modal';

import { getNewRegistersTable, getCsvNewRegistersReport, resendIntegration } from '../app/store/actions/newRegisters';

import { history } from '../routers/AppRouter';
import ROUTES from '../data/routes';

class RegisterMonitorPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      limit: 20,
      page: 1,
      search: '',
      showModal: false,
      modal: {},
      orderBy: 'ASC',
      field: 'idContato',
    };
  }

  componentDidMount() {
    this.getNewRegistersTable();
  }

  updateValues = async (search = '', page = 1) => {
    await this.setState({ search, page });
    await this.getNewRegistersTable();
  }

  resync = async (row) => {
    await this.props.resendIntegration(row);
    await this.getNewRegistersTable();
  }

  getNewRegistersTable = async () => {
    const {
      search, page, limit, orderBy = '', field = '',
    } = this.state;
    const skip = (page - 1) * limit;

    await this.props.getNewRegistersTable(limit, skip, search, orderBy, field);
  }

  failedModal = async (type = '', message = '') => {
    await this.setState({
      showModal: true,
      modal: {
        title: I18n.t('failed'),
        body: this.bodyModal(message || I18n.t(`failed${type}`)),
        okBtn: I18n.t('ok'),
        action: false,
      },
    });
  }

  bodyModal = message => (
    <div>
      <div className="text-align-modal">
        <h1>{I18n.t('failed')}</h1>
      </div>

      <div
        className="text-align-modal"
        style={{
          maxHeight: '50vh', overflowY: 'auto', backgroundColor: 'rgb(246,246,246)', padding: '12px',
        }}
      >
        <code style={{
          color: 'rgb(47,51,55)',
          backgroundColor: 'transparent',
        }}
        >
          {message}
        </code>
      </div>
    </div>
  )

  sortTable = async (field, orderBy) => {
    await this.setState({ orderBy, field });
    await this.getNewRegistersTable();
  }

  render() {
    const {
      limit, page, modal, showModal,
    } = this.state;
    const { newRegisters = [] } = this.props;

    const tableHeader = [
      { key: 'id', value: 'ID' },
      { key: 'email', value: I18n.t('email') },
      { key: 'name', value: `${I18n.t('companyName')} / ${I18n.t('name')}` },
      { key: 'cnpj', value: `${I18n.t('cnpj')} / ${I18n.t('cpf')}` },
      { key: 'address', value: I18n.t('address') },
      { key: 'number', value: I18n.t('number') },
      { key: 'city', value: I18n.t('city') },
      { key: 'state', value: I18n.t('state') },
      { key: 'phone', value: I18n.t('phone') },
      { key: 'createdAt', value: I18n.t('registerDate') },
      { key: 'syncTotvs', value: 'Totvs' },
      { key: 'syncSphere', value: 'Sphere' },
      { key: 'action', value: I18n.t('action') },
    ];

    const tableData = (newRegisters.newRegisters || []).map((row, index) => ({
      key: index,
      ...row,
      ...(row.typeDoc && row.typeDoc === 'cnpj')
        ? {
          cnpj: StringMask.apply(row.cnpj, '00.000.000/0000-00'),
          name: row.companyName,
        }
        : {
          cnpj: StringMask.apply(row.cnpj, '000.000.000-00'),
          name: `${row.firstName} ${row.lastName}`,
        },
      syncTotvs: row.codEmitente ? (
        <button
          type="button"
          className="btn btn-success btn-can-approve "
        >
          <Translate value="integrated" />
        </button>
      ) : (
        <button
          type="button"
          className="btn btn-danger btn-can-approve"
          onClick={() => this.failedModal('Totvs', row.errorClient)}
        >
          <Translate value="failed" />
        </button>
      ),
      syncSphere: row.idContato ? (
        <button
          type="button"
          className="btn btn-success btn-can-approve "
        >
          <Translate value="integrated" />
        </button>
      ) : (
        <button
          type="button"
          className="btn btn-danger btn-can-approve"
          onClick={() => this.failedModal('Sphere', row.errorContact)}
        >
          <Translate value="failed" />
        </button>
      ),
      action: (
        <div className="btn-group" role="group" aria-label="Button group with nested dropdown">
          <div className="btn-group" role="group">
            <button
              id="btnGroupDrop1"
              type="button"
              className="btn btn-secondary dropdown-toggle"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <Translate value="action" />
            </button>
            <div className="dropdown-menu" aria-labelledby="btnGroupDrop1">
              {(row.codEmitente && row.idContato) ? (
                <button
                  type="button"
                  onClick={() => history.push({
                    pathname: ROUTES.REGISTER_MONITOR_DETAILS,
                    screenComming: ROUTES.REGISTER_MONITOR,
                    item: row,
                  })}
                  className="dropdown-item dropdown-table"
                >
                  <Translate value="details" />
                </button>
              ) : (
                <div>
                  <button
                    type="button"
                    className="dropdown-item dropdown-table"
                    onClick={() => history.push({
                      pathname: ROUTES.REGISTER_MONITOR_EDIT,
                      screenComming: ROUTES.REGISTER_MONITOR,
                      item: row,
                    })}
                  >
                    <Translate value="edit" />
                  </button>
                  <button
                    type="button"
                    className="dropdown-item dropdown-table"
                    onClick={() => this.resync(row)}
                  >
                    <Translate value="resendIntegration" />
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      ),
    }));

    const tableButtons = (
      <React.Fragment>
        <button
          onClick={() => this.props.getCsvNewRegistersReport()}
          type="button"
          className="btn btn-secondary margin-left-10"
        >
          <Translate value="export" />
        </button>
      </React.Fragment>
    );

    return (
      <div className="main-div-tables">
        <ModalComponent
          title={modal.title}
          body={modal.body}
          visible={showModal}
          closeModal={() => this.setState({ showModal: false })}
          titleOkButtoon={modal.okBtn}
          size={{ width: '40%' }}
          id="integrationError"
          type="integrationError"
          showButtons
          showCancel={modal.action}
          confirmModal={() => this.setState({ showModal: false })}
        />

        <Table
          title={I18n.t('registerMonitor')}
          buttons={tableButtons}
          header={tableHeader}
          lines={tableData}
          page={page}
          perPage={limit}
          count={newRegisters.count && newRegisters.count.count}
          searchItems={this.updateValues}
          showItemsCount
          sortTable={this.sortTable}
        />
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  getNewRegistersTable: (limit, skip, search, order, field) => dispatch(
    getNewRegistersTable(limit, skip, search, order, field),
  ),
  getCsvNewRegistersReport: () => dispatch(getCsvNewRegistersReport()),
  resendIntegration: register => dispatch(resendIntegration(register)),
});

const mapStateToProps = state => ({
  newRegisters: state.newRegisters.newRegisters,
});

export default connect(mapStateToProps, mapDispatchToProps)(RegisterMonitorPage);
